export * from './IconFishboneStroked';
